import { useMsal } from '@azure/msal-react';
import {
    useState,
} from 'react';
import { useParams, useNavigate } from 'react-router';

import useAccountContext from '../../../authentication/hooks';
import AppDetails from './appDetails';

import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';

import { CustomBreadcrumbItem } from '../../../components/Breadcrumb';
import useBodyClass from '../../../components/Utilities/useBodyClass';

const TAApplicationManage = () => {
    const { accounts, instance } = useMsal();
    const { id } = useParams();
    const account = useAccountContext();
    const navigate = useNavigate();
    const breadcrumbs: CustomBreadcrumbItem[] = [
        { to: '/', text: 'Dashboard' },
        { to: '', text: `[New certificate] (${id})` },
    ];
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useHtmlTitle(`[New certificate] (${id}) manage | NMI Services portal`);
    useBodyClass('pa-application-manage');

    return (
        <AppDetails name='' isSummary />
    );
};

export default TAApplicationManage;
